export enum PaymentInterval {
	Month,
	Year,
	OneTime,
}

export const PaymentIntervalToActiveName: Record<PaymentInterval, string> = {
	[PaymentInterval.Month]: "Monthly",
	[PaymentInterval.Year]: "Yearly",
	[PaymentInterval.OneTime]: "One-Time",
};

export type PriceDescriptor = {
	id: string;
	cents: number;
};

export type StripePrices = Record<PaymentInterval, PriceDescriptor>;

export type PricesMap = Record<PaymentInterval, undefined>;

export type StripeTier = {
	activations: number;
	title: string;
	description: string;
	features: readonly string[];
	is_best_deal: boolean;
	prices: PricesMap;
};

export const DEV_STRIPE_TIERS: Record<string, StripeTier> = {
	prod_NC6XOKwwTNZ4GD: {
		activations: 1,
		title: "Premium",
		prices: {
			[PaymentInterval.Month]: undefined,
			[PaymentInterval.Year]: undefined,
			[PaymentInterval.OneTime]: undefined,
		},
		description: "Fully unlock sesh! Get repeating events, ",
		features: [
			"Repeating events",
			"Custom RSVP options",
			"Full GCal sync",
			"Unlimited server logs",
			"Unlimited event templates",
			"Close RSVPs early",
			"Priority support",
			"...and much more!",
		],
		is_best_deal: false,
	},
	prod_NC6iPVmx2SkRzQ: {
		activations: 3,
		title: "Premium Bundle",
		prices: {
			[PaymentInterval.Month]: undefined,
			[PaymentInterval.Year]: undefined,
			[PaymentInterval.OneTime]: undefined,
		},
		description: "Description goes here",
		features: [
			"Repeating events",
			"Custom RSVP options",
			"Full GCal sync",
			"Unlimited server logs",
			"Unlimited event templates",
			"Close RSVPs early",
			"Priority support",
			"...and much more!",
		],
		is_best_deal: true,
	},
} as const;

export const PRODUCTION_TIERS: Record<string, StripeTier> = {
	prod_NCrwD9OIe8q3ep: {
		activations: 1,
		title: "Premium",
		prices: {
			[PaymentInterval.Month]: undefined,
			[PaymentInterval.Year]: undefined,
			[PaymentInterval.OneTime]: undefined,
		},
		description: "Fully unlock sesh! Get repeating events, ",
		features: [
			"Repeating events",
			"Custom RSVP options",
			"Full GCal sync",
			"Unlimited server logs",
			"Unlimited event templates",
			"Priority support",
			"...and much more!",
		],
		is_best_deal: false,
	},
	prod_NCrxDlEHuriMPU: {
		activations: 3,
		title: "Premium Bundle",
		prices: {
			[PaymentInterval.Month]: undefined,
			[PaymentInterval.Year]: undefined,
			[PaymentInterval.OneTime]: undefined,
		},
		description: "Description goes here",
		features: [
			"Repeating events",
			"Custom RSVP options",
			"Full GCal sync",
			"Unlimited server logs",
			"Unlimited event templates",
			"Priority support",
			"...and much more!",
		],
		is_best_deal: true,
	},
} as const;

export type StripeProductId = keyof typeof DEV_STRIPE_TIERS;

export function getTiersWithoutPrices() {
	let is_on_production = false;
	if (typeof window !== "undefined") {
		// web
		is_on_production =
			window?.location?.host?.includes("sesh.fyi") &&
			!window?.location?.host?.includes("beta");
	} else if (
		process.env.NODE_ENV === "production" &&
		!process.env.SESH_IS_STAGING
	) {
		is_on_production = true;
	}

	return is_on_production ? PRODUCTION_TIERS : DEV_STRIPE_TIERS;
}

export function getRawProductWithoutPrices(product_id: string) {
	return getTiersWithoutPrices()[product_id as StripeProductId];
}

// const PRODUCTION_STRIPE = {};

export type SubscriptionChoice = {
	span: PaymentInterval;
	id: StripeProductId;
};
